<template>
    <div>欢迎光临本系统</div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {

    };
  },
  methods: {

  },
};


</script>

<style scoped lang='stylus'>

</style>
